function vhToPx(vh: number, windowHeight: number): number {
  return (vh / 100) * windowHeight;
}

function pxToPercent(parentHeight: number, px: number): number {
  return (px * 100) / parentHeight;
}

export { vhToPx, pxToPercent };
